import {createStore} from 'vuex'
import router from "@/router";

export default createStore({
	state: {
		ImageUrl: "http://120.78.92.171:8080/Image",
		prefix: '/EN',
		width: document.body.clientWidth,
		zhongying: "true",
		barUrlList: [],
		bar: "Home",
		navigationBar: [
			{
				title: "Home",
				url: "/"
			},
			{
				title: "About us",
				url: "/aboutUs",
				bar: [{
					name: 'Company Profile',
					footer:'Profile',
					url: "/aboutUs",
				}, {
					name: 'Company Honors',
					footer:'Honors',
					url: "/ListHonor",
				}, {
					name: 'Company Culture',
					footer:'Culture',
					url: "/Culture",
				}]
			},
			{
				title: "Product",
				url: "/Products",
				bar: [
					{
						"name": "Optoelectronic Chip",
						"title": 1,
						"url": "/Products?Type=1",
						"list": [
							{
								"name": "50G",
								"url": "/Products?Type=1&working=13"
							}
						]
					},
					{
						"name": "Optical Engine",
						"title": 2,
						"url": "/Products?Type=2",
						"list": [
							{
								"name": "10G",
								"url": "/Products?Type=2&working=9"
							},
							{
								"name": "25G",
								"url": "/Products?Type=2&working=10"
							},
							{
								"name": "100G",
								"url": "/Products?Type=2&working=11"
							},
							{
								"name": "400G",
								"url": "/Products?Type=2&working=12"
							}
						]
					},
					{
						"name": "Optical Modules",
						"title": 3,
						"url": "/Products?Type=3",
						"list": [
							{
								"name": "DCN&DCI",
								"url": "/Products?Type=3&type=1"
							},
							{
								"name": "Telecom IP",
								"url": "/Products?Type=3&type=3"
							},
							{
								"name": "Wireless Access",
								"url": "/Products?Type=3&type=2"
							}
						]
					}
				]
			},
			{
				title: "Contact",
				url: "/ContactUs",
				bar: [ {
					name: 'Contact us',
					url: "/ContactUs",
				}]
			},
		],
	},
	getters: {},
	mutations: {
		setWidth(state, res) {
			state.width = res
		},
		setNavigationBar(state, res) {
			state.navigationBar[2].bar = res
		},
		gotoUrl(state, res) {
			console.log(res)
			if (sessionStorage.barTitleUrl == res.barTitleUrl) {
				router.replace(state.prefix + res.url).then(r => {
					window.scrollTo(0, 0);
				})
			} else {
				router.push(state.prefix + res.url).then(r => {
					window.scrollTo(0, 0);
				})
			}
			sessionStorage.bar = res.bar
			sessionStorage.barUrl = res.url
			sessionStorage.barTitleUrl = res.barTitleUrl
			state.bar = res.barTitleUrl
		},

		getBarList(state, res) {
			state.bar = sessionStorage.barTitleUrl
			for (let item of state.navigationBar) {
				if (item.url == sessionStorage.barTitleUrl) {
					console.log(state)
					state.barUrlList = item.bar;
				}
			}
		}
	},
	actions: {},
	modules: {}
})
